import { DateFormat, formatDate, now } from "common";
import { Dayjs } from "dayjs";
import create from "zustand";
import { CreatedAtRangeProps, DateFilterRange } from "./analyticsFilterStore";

const defaultRange = () => {
    return { from: now().subtract(1, "month").startOf("day"), to: now().endOf("day") };
};

interface GiftStoreState {
    to?: Dayjs;
    from?: Dayjs;
    getFrom: () => Dayjs;
    getTo: () => Dayjs;
    type: GiftStoreProductType;
    setFrom: (date: Dayjs) => void;
    setTo: (date: Dayjs) => void;
    getDateParams: () => CreatedAtRangeProps;
    setType: (type: GiftStoreProductType) => void;
}

export enum GiftStoreProductType {
    ALL = "All",
    STORE_CREDIT = "Store Credit",
    GIFT = "Gift",
}

export const useGiftFilterStore = create<GiftStoreState>((set, get) => ({
    from: undefined,
    to: undefined,
    type: GiftStoreProductType.ALL,

    getDateParams() {
        const params = [
            formatDate(get().getFrom(), DateFormat.DATE_TIME_ISO),
            formatDate(get().getTo(), DateFormat.DATE_TIME_ISO),
        ];
        return { [DateFilterRange.CREATED_AT]: params.join(",") };
    },

    getFrom() {
        return get().from ?? defaultRange().from;
    },

    getTo() {
        return get().to ?? defaultRange().to;
    },

    setFrom(from: Dayjs) {
        set(() => ({ from }));
    },

    setTo(to: Dayjs) {
        set(() => ({ to }));
    },

    setType(type: GiftStoreProductType) {
        set(() => ({ type }));
    },
}));
